import { customerSchema } from '@sophocles/entities/Customer';
import { radioSchema } from '@sophocles/entities/Radio';
import { siteSchema } from '@sophocles/entities/Site';
import { siteGroupSchema } from '@sophocles/entities/SiteGroup';
import InventoryLocationSchema from '@sophocles/features/inventory/inventoryLocations/schema';
import { schema } from 'normalizr';

const RadioLocationTagSchema = new schema.Entity('radioLocationTags');

const RadioLocationSchema = new schema.Entity('radioLocations', {
  customer: customerSchema,
  site_group: siteGroupSchema,
  site: siteSchema,
  radio: radioSchema,
  inventory_location: InventoryLocationSchema,
  tags: [RadioLocationTagSchema],
});

export default RadioLocationSchema;
